import React from "react";
import { useAuth } from "@/hooks/use-auth";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function UserMenu() {
  const { user, logout } = useAuth();
  
  const handleLogout = async () => {
    await logout();
  };
  
  // Get user initials for avatar
  const userInitials = user?.fullName
    ? user.fullName.split(' ').map(n => n[0]).join('')
    : user?.email?.[0]?.toUpperCase() || 'U';

  return (
    <div className="p-4 border-t border-neutral-700">
      <div className="flex items-center min-w-0">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="p-0 h-auto w-full min-w-0 justify-start rounded-md">
              <div className="flex items-center w-full p-2">
                <div className="flex-shrink-0 h-8 w-8 rounded-full bg-primary flex items-center justify-center text-white font-medium">
                  {userInitials}
                </div>
                <div className="ml-3 flex-1 text-left min-w-0">
                  <div className="text-sm font-medium truncate">
                    {user?.fullName || user?.email}
                  </div>
                  <div className="text-xs text-neutral-400 truncate">
                    {user?.email}
                  </div>
                </div>
              </div>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-48">
            <DropdownMenuItem onClick={handleLogout} className="cursor-pointer">
              <LogOut className="mr-2 h-4 w-4" />
              <span>Log out</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <Button 
          variant="ghost" 
          size="sm" 
          className="rounded-full p-1 ml-2 hover:bg-neutral-700 text-neutral-400"
          onClick={handleLogout}
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
